import type { EntityAdapter, EntityState } from '@ngrx/entity';
import type { Action } from '@ngrx/store';
import type { ProjectOutput } from 'core/http/dev';
import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as AssignedProjectsActions from './assigned-projects.actions';

export interface AssignedProjectsState extends EntityState<ProjectOutput> {
  isLoaded: boolean;
}

const adapter: EntityAdapter<ProjectOutput> = createEntityAdapter();

export const initialAssignedStateState = adapter.getInitialState<AssignedProjectsState>({
  isLoaded: false,
});

const reducer = createReducer(
  initialAssignedStateState,
  on(AssignedProjectsActions.saveAssignedProjectsInState, (state, { projects }) => adapter.setAll(projects, state)),
  on(AssignedProjectsActions.markAssignedProjectsLoaded, state => ({ ...state, isLoaded: true })),
  on(AssignedProjectsActions.resetAssignedProjects, state => ({ ...adapter.removeAll(state), isLoaded: false })),
);

export function assignedProjectsReducer(state: AssignedProjectsState | undefined, action: Action): AssignedProjectsState {
  return reducer(state, action);
}

export const {
  selectAll,
  selectEntities,
} = adapter.getSelectors();
